import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, UpdateInvoiceStatusPayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'UPDATE_INVOICE_STATUS_',
  }
);

export interface UpdateInvoiceStatusState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface UpdateInvoiceStatusRequestAction {
  payload: UpdateInvoiceStatusPayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: UpdateInvoiceStatusState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: UpdateInvoiceStatusState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: UpdateInvoiceStatusState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: UpdateInvoiceStatusState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: UpdateInvoiceStatusState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const updateInvoiceStatus = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const UpdateInvoiceStatusTypes = Types;
export const UpdateInvoiceStatusActions = Creators;
